<section class="hero wave-bg">
  <div class="container hero-content">
    <h1>
      Agence de Développement Web :
      <span class="accent"> Expertise Technique et Proximité Locale</span>
    </h1>
    <p class="hero-description">
      Alliez la puissance d'une expertise technique de niveau senior à la réactivité d'une équipe à taille humaine. Basée à Paris et Châteauroux, notre agence accompagne les entreprises dans leurs défis de <a routerLink="/refonte-modernisation-legacy" style="color: inherit; text-decoration: underline;">modernisation legacy</a> et de <a routerLink="/maintenance-tma-nodejs-angular" style="color: inherit; text-decoration: underline;">maintenance applicative</a>.
    </p>
     <div class="cta-row">
       <a 
        href="https://cal.mesh-box.fr/ogirodin/30min"
        class="button primary large" 
        data-cal-link="ogirodin/30min" 
        data-cal-config='{"layout":"month_view"}'
      >
        Échanger sur votre projet
      </a>
    </div>
  </div>
</section>

<section class="section alt">
  <div class="container max-w-5xl">
    <div class="grid-2 gap-12">
      <div>
           <h2>Agence Web Châteauroux : Votre Partenaire en Région Centre</h2>
           <p class="mb-4">
              Située au cœur de l'Indre, notre agence de Châteauroux est le moteur de notre production. En choisissant un partenaire local, vous bénéficiez d'une communication simplifiée et d'un engagement fort dans le développement économique du territoire.
           </p>
           <p>
              Nous accompagnons les PME et industries locales dans la digitalisation de leurs processus métiers, en apportant des solutions technologiques robustes et pérennes.
           </p>
      </div>
      <div>
           <h2>Expertise Parisienne pour Projets Stratégiques</h2>
           <p class="mb-4">
              Nos bureaux à Paris nous permettent de rester au plus près des centres décisionnels et des grands comptes. Cette double implantation nous offre une vision globale du marché et des enjeux technologiques actuels.
           </p>
           <p>
              Nous intervenons sur des missions de conseil architectural, d'audit de sécurité et de pilotage de projets complexes nécessitant une expertise technique de pointe.
           </p>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <h2 style="text-align: center; margin-bottom: 3rem;">Une culture de l'excellence et de la transparence</h2>
    <div class="max-w-4xl mx-auto mb-12">
      <p class="mb-6">
        Chez Mesh Box, nous croyons que la réussite d'un projet web repose sur trois piliers : une compréhension métier fine, une architecture technique solide et une communication transparente. Nous ne nous contentons pas de livrer du code ; nous construisons des solutions qui soutiennent votre croissance à long terme.
      </p>
      <p>
        En tant qu'agence agréée par le Ministère de la Recherche au titre du <strong>Crédit Impôt Innovation (CII)</strong>, nous témoignons de notre capacité à mener des projets de développement innovants et techniquement ambitieux.
      </p>
    </div>

    <div class="trust-logos" style="margin-top: 2rem; display: flex; justify-content: center; gap: 3rem; flex-wrap: wrap; align-items: center;">
       <img src="/assets/logos/ingenico.svg" alt="Ingenico - Solutions de paiement sécurisées" width="200" height="100" style="max-height: 80px; filter: grayscale(1); opacity: 0.8;" />
       <img src="/assets/logos/bouygues.svg" alt="Bouygues Telecom - Opérateur télécom" width="120" height="60" style="max-height: 60px; filter: grayscale(1); opacity: 0.8;" />
       <img src="/assets/logos/citroen.png" alt="Citroën - Automobile" width="60" height="60" style="max-height: 60px; filter: grayscale(1); opacity: 0.8;" />
     </div>            
     <p style="margin-top: 2rem; text-align: center; max-width: 800px; margin: 2rem auto 0;">
        Qu'il s'agisse de grands groupes ou de startups en phase de scale-up, nous apportons la même rigueur méthodologique et le même soin à la qualité du code.
    </p>
    
    <div class="mt-12">
      <h3 style="text-align: center; margin-bottom: 1.5rem; color: var(--muted); font-size: 1rem; text-transform: uppercase; letter-spacing: 0.1em;">Agréments Ministériels</h3>
      <app-cii-badge variant="hero" />
    </div>
  </div>
</section>

<section class="section alt" style="background: var(--panel); border-top: 1px solid var(--border);">
  <div class="container max-w-4xl">
    <h2>Maîtrise technologique : Pourquoi nous choisissons React ou Angular</h2>
    <div style="background: var(--card); padding: 2rem; border-radius: 12px; border: 1px solid var(--border); box-shadow: var(--shadow);">
      <p class="mb-4">
        Le choix d'une stack technique ne doit jamais être une question de mode, mais une réponse à des besoins métier précis.
      </p>
      <div class="grid-2 gap-8 mb-6">
        <div>
          <h4 style="color: #61dafb;">React (Modern Web)</h4>
          <p class="text-sm">Privilégié pour sa flexibilité, son écosystème massif et ses excellentes performances pour le SEO et le rendu statique (SSG).</p>
        </div>
        <div>
          <h4 style="color: #dd0031;">Angular (Enterprise Ready)</h4>
          <p class="text-sm">Choisi pour les applications métier complexes nécessitant une structure rigoureuse, un typage strict avec TypeScript et une maintenabilité sur le long terme.</p>
        </div>
      </div>
      <p style="font-style: italic; border-left: 4px solid var(--brand); padding-left: 1rem; color: var(--text);">
        "Notre rôle est de vous conseiller sur la technologie qui servira au mieux vos objectifs business, en garantissant un coût de maintenance optimisé."
      </p>
    </div>
  </div>
</section>

<section class="section cta-final">
  <div class="container">
    <h2>Construisons ensemble votre futur numérique</h2>
    <p>Vous avez un projet de développement ou une application à moderniser ? Rencontrons-nous à Paris ou à Châteauroux.</p>
    <a 
      href="https://cal.mesh-box.fr/ogirodin/30min"
      class="button primary large" 
      data-cal-link="ogirodin/30min" 
      data-cal-config='{"layout":"month_view"}'
    >
      Prendre rendez-vous
    </a>
  </div>
</section>